export default "__VITE_ASSET__DZ41u1RB__"